import React, { useState, useEffect, useRef } from 'react'
import CraneSideBar from '../../../Component/Customers/slidebar/CraneSideBar.jsx'
import search from '../../../Assets/home2/search.svg'
import icon18 from '../../../Assets/crane/icon18.svg'
import icon6 from '../../../Assets/crane/icon6.svg'
import icon7 from '../../../Assets/crane/icon7.svg'
import rightarrow from '../../../Assets/navbar/right-arrow.svg'
import img2 from '../../../Assets/add/img2.png'
import icon11 from '../../../Assets/crane/icon11.svg'
import img3 from '../../../Assets/add/img3.png'
import MapForVendorDistance from '../Map/MapForVendorDistance.jsx'
import '../FirstPageDesigns/FirstPage.css';
import searchinterfacesymbol from '../../../Assets/search-interface-symbol.png'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from "../../../axiosInstance.js";

import assignedTask from '../../../Assets/assignedTask.png'
import comingCrane from '../../../Assets/comingCrane.png'
import checksuccess from '../../../Assets/checksuccess.png'
import crossUser from '../../../Assets/crossUser.png'
import NoDataFound from '../../../Component/Customers/Cards/NoDataFound.jsx';
import filterUser from '../../../Assets/filterUser.png'
import telephonecall from '../../../Assets/telephonecall.png'
import Modal from '../../../Component/CompanyAdmin/Location1/Modal.jsx';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import NetworkWifiIcon from '@mui/icons-material/NetworkWifi';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import SocialDistanceIcon from '@mui/icons-material/SocialDistance';
import { useWebSocket } from '../../../context/WebSocketContext.jsx' // i am edited websocket;
import { ClipLoader } from 'react-spinners';
import { Alert } from '@mui/material';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import ModalButton from '../FirstPageDesigns/ModalButton.jsx';
import RatingModal from './RatingModal.jsx';
import CraneFirstPage from './CraneFirstPage.jsx'
import { NotepadText } from 'lucide-react'


function CurrentOrdersList({ vehicleNumber }) {

    const navigate = useNavigate()
    const { messages, setMessages } = useWebSocket();
    const scrollRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const { state } = useLocation();
    const [currentStage, setCurrentStage] = useState([]); // Example stage
    console.log("currentStage123", currentStage)
    const [isImageContainerVisible, setIsImageContainerVisible] = useState(false);
    const [data, setData] = useState([]);
    console.log('data189378923742', data)
    const [dummyData, setDummyData] = useState([]);
    const [currentItems, setCurrentItems] = useState(data);
    const [vendorCurrentLatitude, setVendorCurrentLatitude] = useState("")
    const [vendorCurrentLongitude, setVendorCurrentLongitude] = useState("")
    const [selectedAction, setSelectedAction] = useState(null)
    const [alertMessage, setAlertMessage] = useState(null);
    const [alertType, setAlertType] = useState(null);
    const [distance, setDistances] = useState([])
    console.log("distacneeerwerw", distance)
    const [avg, setAvg] = useState([])
    const [openFilterModal, setOpenFilterModal] = useState(false)
    const [filter, setFilter] = useState('')
    const [doneFetching, setDoneFetching] = useState(false)

    console.log("avg", avg)
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    const stages = [
        { label: "assigned", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/assignedTask.png' },
        { label: "moved", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/comingCrane.png' },
        { label: "reached", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/checksuccess.png' },
    ];

    console.log('isImageContainer', isImageContainerVisible)

    useEffect(() => {

        getData();
        setMessages([]);
        console.log("token", token, userId);
        if (token === "" || userId === "") {
            navigate("/");
        }
    }, [token, userId, navigate]);

    const getFilteredData = (filter) => {
        console.log("data is here");

        const filteredData = [];

        const now = new Date();  // Current date and time
        const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
        const yesterday = new Date(now.getTime() - oneDay); // Yesterday's date and time
        const weekBefore = new Date(now.getTime() - (oneDay * 7));
        const monthBefore = new Date(now.getTime() - (oneDay * 30));

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const todayDate = formatDate(now);
        const yesterdayDate = formatDate(yesterday);
        const weekBeforeDate = formatDate(weekBefore)
        const monthBeforeDate = formatDate(monthBefore)

        console.log("todayDate", todayDate)
        console.log("yesterdayDate", yesterdayDate)


        for (let i = 0; i < dummyData.length; i++) {

            console.log(dummyData[i]);
            // return
            let getTime = dummyData[i]?.details?.systemDate?.split('|');
            let assignedDate = getTime[0];
            let assignedTime = getTime[1];
            let assignedDateTime = new Date(`${assignedDate} ${assignedTime}`);

            if (filter === 'daily') {
                console.log("here i am daily")
                if (assignedDate === todayDate || assignedDate === yesterdayDate) {
                    const timeDifference = now - assignedDateTime;
                    if (timeDifference <= oneDay) {
                        console.log("Match found within last 24 hours:", data[i]);
                        filteredData.push(dummyData[i]);
                    }
                }
            }
            else if (filter === 'weekly') {
                console.log("here i am weekly")
                if (assignedDateTime >= weekBefore && assignedDateTime <= now) {
                    console.log("Match found within last 7 days:", data[i]);
                    filteredData.push(dummyData[i]);
                }
            }
            else if (filter === 'monthly') {
                if (assignedDateTime >= monthBefore && assignedDateTime <= now) {
                    console.log("Match found within last 30 days:", data[i]);
                    filteredData.push(dummyData[i]);
                }
            }
            else if (filter === 'year') {
                const yearBefore = new Date(now.getTime() - (oneDay * 365)); // Calculate date one year ago
                if (assignedDateTime >= yearBefore && assignedDateTime <= now) {
                    console.log("Match found within last year:", dummyData[i]);
                    filteredData.push(dummyData[i]);
                }
            }
        }
        if (filter === 'newest') {
            console.log("Sorting by newest to oldest");
            dummyData.sort((a, b) => {
                const dateA = new Date(a?.details?.systemDate.split('|').join(' '));
                const dateB = new Date(b?.details?.systemDate.split('|').join(' '));
                return dateB - dateA; // Descending order
            });
            setData([...dummyData]);
        } else if (filter === 'oldest') {
            console.log("Sorting by oldest to newest");
            dummyData.sort((a, b) => {
                const dateA = new Date(a?.details?.systemDate.split('|').join(' '));
                const dateB = new Date(b?.details?.systemDate.split('|').join(' '));
                return dateA - dateB; // Ascending order
            });
            setData([...dummyData]);
        }
        else {
            setData(filteredData)
        }
    };

    const settingFilter = (filter) => {
        console.log('settingFilter calling: ');
        console.log("filter", filter)
        setFilter(filter)
        getFilteredData(filter)
        setOpenFilterModal(false)
    }

    const getData = async (e) => {
        console.log('currentService1234123', doneFetching)
        console.log('details123123', `${process.env.REACT_APP_BACKEND_URL}/api/getPersonalAccidentVehicleInfoById/${userId}/not_defined/not-completed`)
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getPersonalAccidentVehicleInfoById/${userId}/not_defined/not-completed`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (response.data.message === "No accident vehicle data found.") {
            setData([])
            setDoneFetching(true)
        }
        else {

            const mergedData = [];
            console.log('response.data.data12312', response.data.data)
            response.data.data.forEach((item) => {
                Object.keys(item).forEach((key) => {
                    if (key.endsWith("Details")) {
                        const serviceName = key.replace("Details", ""); // e.g. "crane", "recoveryVan"
                        const detail = item[key];
                        console.log('detaionsdf', detail)
                        console.log(' detail?.customerAcceptedVendor, !detail?.confirmDoneWorking', detail?.customerAcceptedVendor, detail?.confirmDoneWorking)

                        if (detail?.customerAcceptedVendor && !detail?.confirmDoneWorking) {
                            mergedData.push({
                                ...item,
                                details: detail,
                                currentService: serviceName, // Optional, for icon or logic
                            });
                        }
                    }
                });
            });
            console.log('mergedData', mergedData)


            // Prioritize ones that haven't moved
            console.log('du')
             mergedData.sort((a, b) => {
                const dateA = new Date(a?.details?.customerAcceptedVendorTime.split('|').join(' '));
                const dateB = new Date(b?.details?.customerAcceptedVendorTime.split('|').join(' '));
                return dateA - dateB; // Ascending order
            });
            console.log('dummydata', mergedData)
            // setData([...dummyData]);
            const finalData = [...mergedData];
            // const important = mergedData.filter((i) => !i.details?.vendorMoved);
            // const lessImportant = mergedData.filter((i) => i.details?.vendorMoved);
            // const finalData = [...important, ...lessImportant];

            setData(finalData);
            setDummyData(finalData);
            setDoneFetching(true);
            setCurrentItems(response.data.data);

        }
    };

    const goToMap = (item) => {
        console.log("itemfromgotomap", item)
        console.log("item.accidentLatitude", `${item?.details.accidentLatitude}`, "item.accidentLongitude", item.accidentLongitude, "vendorCurrentLatitude", vendorCurrentLatitude, "vendorCurrentLongitude", vendorCurrentLongitude)
        navigate('/map-vendor-distance', {
            state: {
                accidentLatitude: `${item?.details.accidentLatitude}`,
                accidentLongitude: `${item?.details.accidentLongitude}`,
                vendorLatitude: vendorCurrentLatitude,
                vendorLongitude: vendorCurrentLongitude,
                vehicleNo: `${item?.details.vehicleNo}`,
                fromPage: "statusTracking"
            }
        })
    }

    const getStage = (vendorMoved, approvedReaching) => {
        return approvedReaching ? 2 : vendorMoved ? 1 : 0;
    }

    useEffect(() => {
        console.log('data changes', data.length, currentStage.length)
        console.log('curren4123', doneFetching)
        if (data.length > 0 && doneFetching === true) {
            console.log("push avg")

            const newAvg = Array(data.length).fill(0);

            const newCurrentStage = data.map((item) => {
                console.log("gostrage1")
                let gotStage = getStage(item?.details?.vendorMoved, item?.details?.approvedReaching)
                console.log("gostrage", gotStage)
                return gotStage;
            })
            setAvg(newAvg);
            setCurrentStage(newCurrentStage);

        }

    }, [data, doneFetching])

    function haversine(lat1, lon1, lat2, lon2) {
        console.log("accident latitude", lat1)
        console.log("accident longtitude", lon1)
        console.log("vehicle latitiude", lat2)
        console.log("vehicle longtitude", lon2)

        const toRad = (value) => (value * Math.PI) / 180;
        const R = 6371; // Earth radius in km

        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;
        return distance;
    }

    const getVendorLocation = async (currentServiceId, accidentLatitude, accidentLongitude, index) => {
        try {
            console.log("disntaceadfafdaf", distance)
            console.log("craninging", currentServiceId, accidentLatitude, accidentLongitude, index)

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVendorCurrentLocation/${currentServiceId}`, { headers: { Authorization: `Bearer ${token}` } });
            if (response.data.status === true) {
                let vendorCurrentLatitude = response.data.data[0].latitude;
                let vendorCurrentLongitude = response.data.data[0].longitude;
                setVendorCurrentLatitude(vendorCurrentLatitude)
                setVendorCurrentLongitude(vendorCurrentLongitude)
                console.log("accidentLatitude, accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitud", accidentLatitude, accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitude)
                const calculatedDistance = haversine(accidentLatitude, accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitude).toFixed(2);

                distance.push(calculatedDistance)
            }
            else if (response.data.message === "User Not found take Location") {
                console.log("User Not found take Location")
            }
        } catch (error) {
            console.log("error in get Vendor Location", error.message)
        }
    }

    const getVendorRating = async (crane) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/customersRating/${crane}/${crane}`);
            console.log("coming Customer Rating", response.data)
            if (response.data.status === 404) {
                console.log("Not Found")
                avg.push(0)
            }
            else if (response.data.status === true) {
                let customerRating = response.data.data;
                console.log("coming Customer Rating", customerRating)
                if (customerRating.length !== 0) {
                    let average = customerRating.reduce((acc, item) => acc + parseInt(item.feedbackRatingCrane), 0);

                    avg.push(average / customerRating.length);
                }
            }
        } catch (error) {
            console.log("Error from get Vendor Rating", error.message)
        }
    }

    const [searchValue, setSearchValue] = useState('');
    useEffect(() => {
        if (vehicleNumber && dummyData.length) {
            setSearchValue(vehicleNumber)
            handleSearch(vehicleNumber)

        }
    }, [vehicleNumber, dummyData])

    // useEffect(() => {
    //     return () => setSearchValue("")
    // }, [])
    const handleSearch = (inputValue) => {
        const value = inputValue?.toLowerCase() ?? searchValue.toLowerCase();
        setSearchValue(value);
        const newRows = dummyData.filter((row) => {
            const formattedId = String(row.id).padStart(4, '0').toLowerCase(); // Make sure the formatted ID is lowercase
            const searchLower = value; // Use the updated search value directly

            const idValue = formattedId.includes(searchLower);
            const vehicleNoValue = (row?.details?.vehicleNo ?? '').toLowerCase().includes(searchLower);
            const chassisNoValue = (row?.details?.chassisNo ?? '').toLowerCase().includes(searchLower);

            return vehicleNoValue || chassisNoValue;
        });

        setData(newRows);
    };

    console.log("{item?.details?.customerAcceptedVendor", data[0]?.details?.customerAcceptedVendor)
    console.log("disptan", data.length, doneFetching, distance.length, avg.length)


    const [isCancelContainerVisible, setIsCancelContainerVisible] = useState(false);
    const [reasonsForDrop, setReasonsForDrop] = useState(false);
    const [selectedReasons, setSelectedReasons] = useState([]);
    const [otherReason, setOtherReason] = useState(null);
    const handleSelectReason = (reason) => {
        if (selectedReasons.includes(reason)) {
            // Remove from selected if already in array
            setSelectedReasons(selectedReasons.filter((item) => item !== reason));
        } else {
            // Add to selected array
            setSelectedReasons([...selectedReasons, reason]);
        }
    };
    const [errorMessage, setErrorMessage] = useState("");
    const reasons = [
        "Too much time taking",
        "Got Other Services",
        "Not Needed Now", "Changed my mind"
    ];
    const [isLoading, setIsLoading] = useState(false);
    const [alreadyCancelled, setAlreadyCancelled] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });
    const [cancelled, setCancelled] = useState(false);
    const [showFull, setShowFull] = useState(false);
    const [showFull2, setShowFull2] = useState(false);

    const handleScroll = () => {
        if (!scrollRef.current) return;
        const scrollX = scrollRef.current.scrollLeft;
        const itemWidth = scrollRef.current.firstChild?.offsetWidth || 1;
        const newIndex = Math.round(scrollX / itemWidth);
        setActiveIndex(newIndex);
    };


    return (
        <>
            <div className='fixed bottom-[6rem] w-full bg-transparent flex flex-col items-center py-2 text-xs z-50'>
                {data.length > 0 && doneFetching && (
                    <>
                        <div
                            ref={scrollRef}
                            onScroll={handleScroll}
                            className="overflow-x-auto whitespace-nowrap px-2 scroll-smooth no-scrollbar w-full"
                        >
                            {data.map((item, dataIndex) => (
                                <div
                                    key={dataIndex}
                                    onClick={() => {
                                        navigate('/driver-status-tracking', {
                                            state: {
                                                accidentVehicleCode: item?.details?.AccidentVehicleCode,
                                            },
                                        });
                                    }}
                                    style={{boxShadow:'4px 3px 12px 0px'}}
                                    className="inline-block align-top min-w-[80vw] border-1 border-green-600 bg-white rounded-[12px] px-2 py-1 m-2  cursor-pointer "
                                >
                                    <div className="flex justify-around items-center pt-1 mb-1">
                                        <img
                                            src={
                                                item.currentService === 'crane'
                                                    ? 'https://www.ace-cranes.com/images/productimage/168993867620230721.png'
                                                    : 'https://img.freepik.com/premium-photo/charming-white-tow-truck-with-joyful-look-vector-style-art-3d-illustration-isolated-white_1262781-194016.jpg?semt=ais_hybrid&w=740'
                                            }
                                            alt='vehicle'
                                            className='rounded-full h-[2rem] w-[2rem]'
                                        />
                                        <div className="text-[0.60rem] font-semibold">
                                            {item?.details?.vehicleNo}
                                        </div>
                                        <span className="font-satoshi text-[10px] animate-pulse px-[8px] py-[4px] rounded-[10px] font-bold text-blue-600 bg-blue-50">
                                            {Boolean(!item?.details?.vendorMoved) && <span>Ready to move</span>}
                                            {Boolean(item?.details?.vendorMoved) && Boolean(!item?.details?.vendorReached) && <span>On the way</span>}
                                            {Boolean(item?.details?.vendorReached) && Boolean(!item?.details?.approvedReaching) && <span>Confirm</span>}
                                            {Boolean(item?.details?.vendorReached) && Boolean(item?.details?.approvedReaching) && <span>Reached</span>}
                                        </span>
                                        <div className="font-satoshi text-[9px] px-[8px] py-[4px] rounded-[10px] font-semibold text-black-600 bg-green-50">
                                            {parseFloat(item?.details?.totalDistance || 0).toFixed(2)} Km
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Dots */}
                        <div className="flex justify-center space-x-2 mt-1">
                            {data.map((_, index) => (
                                <div
                                    key={index}
                                    className={`w-1.5 h-1.5 rounded-full transition-all duration-200 ${activeIndex === index ? 'bg-[#21a6e9] scale-110' : 'bg-gray-300'
                                        }`}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>
        </>
    );

}

export default CurrentOrdersList;